/**************************************************
 * Nombre:       Motivacion_RG
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import TituloPeqGrande from "../../../Componentes/TituloPeqGrande";
import {Circle} from '@mui/icons-material'
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";
import {formatoMoneda} from "../../../../Utilidades/formatoMoneda";

const Producto_RI = ({item, cupos}) => {
    const {sCell} = useResponsive()

    const IconTexto = ({it}) => {

        return (
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}

            >

                <Grid container size={{xs: 1, sm: 1, md: 1}}>
                    <Circle sx={{width: 16, height: 16}}/>
                </Grid>

                <Grid container size={{xs: 11, sm: 11, md: 11}}>
                    <Typography sx={{fontWeight: 600, fontSize: 18}}>{it.caracteristica}</Typography>
                </Grid>

            </Grid>
        )
    }

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 10}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}>


                        <Grid container size={{xs: 12, sm: 12, md: 7}}>
                            <TituloPeqGrande peq={'Oferta'} grande={'Por Lanzamiento'}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 5}}>
                            <Typography sx={{fontWeight: 400, fontSize: 16, textAlign: 'left', lineHeight: 1.2}}>
                                {item.parrafoProducto}
                            </Typography>
                        </Grid>


                    </Grid>

                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{mt: 10}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={3}
                    >

                        <Grid container size={{xs: 12, sm: 7, md: 7}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>


                                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                                    <img src={item.imgProducto} width={'100%'} height={'auto'}/>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{mt: sCell ? 0 : 4, justifyContent: sCell ? 'center' : 'flex-start'}}>
                                    <Typography sx={{lineHeight: 1, fontWeight: 600}}>
                                        {`${cupos} Packs Vendidos de ${item.cupos} Disponibles`}
                                    </Typography>
                                </Grid>

                            </Grid>

                        </Grid>

                        <Grid container size={{xs: 12, sm: 5, md: 5}}
                              spacing={0}
                              sx={{mt: sCell ? 2 : 0}}
                        >


                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={1}
                            >

                                {item && item.caracteristicas && item.caracteristicas.map((it) => {
                                    return (
                                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 0}}>
                                            <IconTexto it={it}/>
                                        </Grid>

                                    )
                                })}


                            </Grid>


                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                  sx={{mt: 4, justifyContent: sCell ? 'center' : 'flex-start'}}>
                                <Typography sx={{lineHeight: 1}}>Precio De Lanzamiento</Typography>
                            </Grid>
                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                  sx={{mt: 1, justifyContent: sCell ? 'center' : 'flex-start'}}>
                                <Typography sx={{
                                    fontWeight: 800,
                                    fontSize: 48,
                                    lineHeight: 1
                                }}>{`${formatoMoneda(item.valor)} UDS`}</Typography>
                            </Grid>
                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                  sx={{justifyContent: sCell ? 'center' : 'flex-start'}}>
                                <Typography sx={{fontWeight: 400, fontSize: 16, lineHeight: 1, color: '#00000080'}}>
                                    {`Precio Normal ${formatoMoneda(item.valorAnterior)} USD`}
                                </Typography>
                            </Grid>

                        </Grid>

                    </Grid>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Producto_RI

